import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    email
} from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "applicantForgetPassword",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            email: "",
            submitted: false
        };
    },

    validations: {
        email: {
            required,
            email
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.sendResetMail();
        },

        sendResetMail() {
            this.isLoading = true;
            var request = {
                email: this.email
            };
            axios.post("/applicant/forget_password", request)
                .then(response => {
                    if (response.data.msg) {
                        this.isLoading = false;
                        this.$notification.error(response.data.msg, {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } else {
                        this.isLoading = false;
                        this.$notification.success('စကားဝှက်ပြောင်းရန်အီးမေးလ်ကို အောင်မြင်စွာပို့ပြီးဖြစ်ပါသည်။', {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.$router.push({ name: 'applicantLogin' });
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.response.data.msg) {
                        this.isLoading = false;
                        this.$notification.error(error.response.data.msg, {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } else {
                        this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                });
        }
    }
};
